<template>
  <v-avatar
    :size="size"
  >
    <span
      class="initials-icon"
      :aria-label="givenName + surname"
    >{{ initials }}</span>
  </v-avatar>
</template>

<script>
  export default {
    name: "InitialsIcon",
    props: {
      givenName: {
        type: String,
        default: '',
      },
      surname: {
        type: String,
        default: '',
      },
      size: {
        type: String,
        default: "40px",
      }
    },
    computed: {
      initials() {
        const str = this.givenName + " " + this.surname;
        return str.split(" ").map(el => el.charAt(0).toLocaleUpperCase()).join("");
      }
    },
  }
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
.v-application.theme--dark{
  .v-avatar{
    background-color: $ads-light-blue-dark !important;
  }
  .initials-icon{
    color: $ads-navy-dark !important;
  }
}
 .v-avatar{
   background-color: #C7DCF0;
 }
 .initials-icon {
   font-size: 16px !important;
   font-weight: 400 !important;
   line-height: 24px;
   color: #1D428A;
   padding-top: 2px;
   padding-left: 1px;
 }
</style>
